import { network } from 'services/network';

export const plfAnalysis = (params) => {
    const data = new FormData();
    data.append('file', params.file, params.file.name);
    return network
        .post('api/bo/plfAnalysis', data, {
            transformRequest: [
                (data, headers) => {
                    if (headers) {
                        headers['Content-Type'] = 'multipart/form-data';
                    }
                    return data;
                },
            ],
        })
        .then((response) => {
            return response.data;
        });
};
